export const MOBILE_MAIN_CONTENT_ID = 'advancedMainContentWrapperMobile';
export const DESKTOP_MAIN_CONTENT_ID = 'advancedMainContentWrapper';
